import { InternalAxiosRequestConfig } from 'axios';

// eslint-disable-next-line
export const authInterceptor = (token: string) => (
    (req: InternalAxiosRequestConfig) => {
        req.headers!.Authorization = `Bearer ${token}`;
        return req;
    }
);
